import tabs from "./components/tabs";
import navMenu from "./components/menu";
import modalInit from "./components/modal";
import lozad from 'lozad';
import swiperInit from "./components/swiper";

//init lozad
const observer = lozad('.lozad', {
    rootMargin: '100px 0px', // syntax similar to that of CSS Margin
    enableAutoReload: true // it will reload the new image when validating attributes changes
});
observer.observe();
window.addEventListener("DOMContentLoaded", () => {
    tabs();
    navMenu();
    modalInit();
    swiperInit();
});

window.addEventListener('resize', () => {
    swiperInit();
});

//Redirection for Contact Form 7
const siteUrl = window.location.origin;
document.addEventListener( 'wpcf7mailsent', function( event ) {
    window.location.assign(`${siteUrl}/contact-message/`);
}, false );
